import { Company } from './Company';
import { Role } from './CurrentUser';

export class User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  isActive: boolean;
  userOib: string;
  company: Company;
  roles: Role[];

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
      // this.company = new CompanyOld(data.company);
      // this.roles = data.roles ? data.roles.map((value: any) => new Role(value)) : [];
    }
  }

  getFullName() {
    return this.firstName + ' ' + this.lastName;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/User.ts